module.exports = __webpack_public_path__ + "img/[难过].84eda096.svg";